import placeStoneSound from "@/assets/sounds/static/place-stone.wav";

/** Singleton Audio instance for the stone-placement sound effect. */
const placeStoneSoundInstance = new Audio(placeStoneSound);

export default placeStoneSoundInstance;
